import React from "react"
import styled from "styled-components"

const Wrapper = styled.div`
  max-width: 1200px;
  //max-width: 90%;
  margin: 0 auto;
  padding: 0 5%;
`


const ContainerRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`

const HalfPage = styled.div`
  width: 48%;
  @media screen and (max-width: 576px) {
    width: 100%;
  }
`

const FullPage = styled.div`
  width: 100%;
  @media screen and (max-width: 576px) {
    width: 100%;
  }
`

const ThirdPage = styled.div`
  width: 30%;
  @media screen and (max-width: 576px) {
    width: 100%;
  }
`

const QuarterPage = styled.div`
  width: 25%;
  @media screen and (max-width: 768px) {
    width: 100%;
  }
`

const ThreeQuarterPage = styled.div`
  width: 75%;
  @media screen and (max-width: 768px) {
    width: 100%;
  }
`

const TwoThirdsPage = styled.div`
  width: 70%;
  @media screen and (max-width: ${props => props.theme.breakpoints.phone}) {
    width: 100%;
  }
`

const SixtyPage = styled.div`
  width: 60%;
  @media screen and (max-width: ${props => props.theme.breakpoints.tablet}) {
    width: 100%;
  }
`
const FortyPage = styled.div`
  width: 40%;
  @media screen and (max-width: ${props => props.theme.breakpoints.tablet}) {
    width: 100%;
  }
`

interface IProps {
  children: React.ReactNode
}

const Container = ({ children }: IProps) => {
  return <Wrapper>{children}</Wrapper>
}

export default Container

export const Row = ({ children }: IProps) => (
  <ContainerRow>{children}</ContainerRow>
)

export const Half = ({ children }: IProps) => <HalfPage>{children}</HalfPage>

export const Full = ({ children }: IProps) => <FullPage>{children}</FullPage>

export const Third = ({ children }: IProps) => <ThirdPage>{children}</ThirdPage>

export const TwoThird = ({ children }: IProps) => <TwoThirdsPage>{children}</TwoThirdsPage>

export const Quarter = ({ children }: IProps) => <QuarterPage>{children}</QuarterPage>

export const ThreeQuarter = ({ children }: IProps) => <ThreeQuarterPage>{children}</ThreeQuarterPage>

export const Sixty = ({ children }: IProps) => <SixtyPage>{children}</SixtyPage>

export const Forty = ({ children }: IProps) => <FortyPage>{children}</FortyPage>
